/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTriumphpayFieldList.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/triumphpay-field-list";

export class AutogenModelTriumphpayFieldList<RowType extends ModelRow> extends Endpoint<RowType, RowTriumphpayFieldListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTriumphpayFieldList extends ModelRow<RowTriumphpayFieldListFields> {
	constructor(values?: Partial<RowTriumphpayFieldListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTriumphpayFieldListFields {
	company_id: string;
	field_name: string;
	filter_field_name: string;
	filter_field_value: string;
	id: string;
	is_active: string;
	reference_field: string;
	table_name: string;
	triumphpay_transaction_type: string;
}

